import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '../config/config';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LlamadoPacienteService {

  headers = new HttpHeaders({
    'accept': 'application/json',
    'Content-Type': 'application/json',
    apiKey: API_ENDPOINT.apiBox.apiKey,
    "skipApiKeyInterceptor": "true"
  });

  constructor(
    private readonly http: HttpClient
  ) { }

  async getDer(slug: string, request: any): Promise<any> {
    try {
      const url: string = `${ API_ENDPOINT.apiBox.url }/api/TurnosModel/GetDer?slug=${ slug }`;
      return await lastValueFrom(this.http.post(url, request, { headers: this.headers }));
    } catch {
      return { status: false, code: 804, message: "Error al ejecutar la petición", data: [] };
    }
  }

  async emitTurnoLlamado(slug: string, request: any): Promise<any> {
    try {
      const url: string = `${ API_ENDPOINT.apiBox.url }/api/TurnosModel/NewTur?slug=${ slug }`;
      return await lastValueFrom(this.http.post(url, request, { headers: this.headers }));
    } catch {
      return { status: false, code: 804, message: "Error al ejecutar la petición", data: [] };
    }
  }
}
